import { produce } from "immer"
import type { IStateWithPaging, PagingOptions, SortOrder } from "../models/types"
import type { CoMaFilterState, CoMaSortState } from "./../redux/content-manager/content-manager.types"

export function loadPagingOptions<TState extends IStateWithPaging>(
  currentState: TState,
  options: PagingOptions
): TState {
  return produce(currentState, (draftState: TState) => {
    draftState.pagingOptions = options
  })
}

export function getPagingString(pageIndex: number, pageSize: number): string {
  return `pageIndex=${pageIndex}&pageSize=${pageSize}`
}

export function getSortString(orderBy: string, order: SortOrder): string {
  const propertyName = capitalizePropertyName(orderBy)
  return `sortProperty=${propertyName}&isDescending=${order === "desc"}`
}

export function getFilterString(key: string, value: string): string {
  const propertyName = capitalizePropertyName(key)
  return `filterProperty=${propertyName}&filterValue=${value}`
}

export function getQueryString(
  pageIndex: number,
  pageSize: number,
  sortState?: CoMaSortState,
  filterState?: CoMaFilterState
) {
  const pagingString: string = getPagingString(pageIndex, pageSize)
  const filterString: string = shouldFilter(filterState)
    ? `&${getFilterString(filterState!.property, filterState!.value)}`
    : ""
  const sortString: string = shouldSort(sortState) ? `&${getSortString(sortState!.property, sortState!.order)}` : ""

  return `?${pagingString}${filterString}${sortString}`
}

function shouldFilter(filterState: CoMaFilterState | undefined): boolean {
  return filterState !== undefined && !isEmtpyProperty(filterState.property)
}

function shouldSort(sortState: CoMaSortState | undefined): boolean {
  return sortState !== undefined && !isEmtpyProperty(sortState.property)
}

function isEmtpyProperty(property: string): boolean {
  return property === ""
}

function capitalizePropertyName(propertyName: string): string {
  return `${propertyName.charAt(0).toUpperCase()}${propertyName.slice(1)}`
}
